import React from 'react'

/**
 * Structure of properties for move board component
 */
export interface IMoveBoardProps {
    showUp: boolean
    showDown: boolean
    onUp: () => void
    onDone: () => void
    onDown: () => void
}

/**
 * Component used to change the order boards appear in the board list
 * @param props properties required
 */
function MoveBoardComponent(props: IMoveBoardProps) {
    return (
        <div className="container h-100" role="group">
            <div className="row h-100 align-items-center justify-content-center">
                <div className="col-md-2 col-4">
                    {props.showUp && (
                        <button
                            className="btn btn-primary w-100"
                            onClick={props.onUp}>
                            Up
                        </button>
                    )}
                </div>
                <div className="col-md-2 col-4">
                    <button
                        className="btn btn-outline-secondary w-100"
                        onClick={props.onDone}>
                        Done
                    </button>
                </div>
                <div className="col-md-2 col-4">
                    {props.showDown && (
                        <button
                            className="btn btn-primary w-100"
                            onClick={props.onDown}>
                            Down
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export { MoveBoardComponent as default }
